import React from 'react';

import { Button } from '@mui/material';

import RepeatIcon from './assets/repeat.svg';
import useStyles from './styles';

interface Props {
    onRetry?: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
}

const OopsMessage: React.FC<Props> = ({ onRetry, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            <p className={classes.title}>{'We were unable to generate AI insights, please try again'}</p>
            <Button
                variant="contained"
                startIcon={<RepeatIcon />}
                disableElevation
                disableRipple
                onClick={onRetry}
                className={classes.refresh}
            >
                {'Try again'}
            </Button>
        </div>
    );
};

export default OopsMessage;
